import { render, staticRenderFns } from "./ReadBlock.vue?vue&type=template&id=4c7a7381&scoped=true&"
import script from "./ReadBlock.vue?vue&type=script&lang=js&"
export * from "./ReadBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReadBlock.vue?vue&type=style&index=0&id=4c7a7381&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a7381",
  null
  
)

export default component.exports